import { http } from './http';

export interface ApiPermission {
  id: string; //guid
  groupId: number;
  objectId: number;
  objectTypeId: number; // 1 Drawer, 2 DocumentType
  permissionTemplateId: number;
}

function normalizePermission(p: any): ApiPermission {
  return {
    ...p,
    id: p.id,
    groupId: Number(p.groupId),
    objectId: Number(p.objectId),
    objectTypeId: Number(p.objectTypeId),
    permissionTemplateId: Number(p.permissionTemplateId),
  };
}

export async function getPermissions(): Promise<ApiPermission[]> { const data = await http<any[]>('/api/permission'); return Array.isArray(data)? data.map(normalizePermission):[]; }
export async function getDocumentTypePermissionsByGroup(groupId:number): Promise<ApiPermission[]> { const data = await http<any[]>(`/api/permission/DocumentTypeByGroup?userGroupId=${groupId}`); return Array.isArray(data)? data.map(normalizePermission):[]; }
export async function getDrawerPermissionsByDrawer(drawerId:number): Promise<ApiPermission[]> { const data = await http<any[]>(`/api/permission/ByDrawer?drawerId=${drawerId}`); return Array.isArray(data)? data.map(normalizePermission):[]; }
export async function getDocumentTypePermissions(documentTypeId:number): Promise<ApiPermission[]> { const data = await http<any[]>(`/api/permission/ByDocumentType?documentTypeId=${documentTypeId}`); return Array.isArray(data)? data.map(normalizePermission):[]; }
export async function addPermission(permission: Omit<ApiPermission,'id'>): Promise<ApiPermission> { return normalizePermission(await http('/api/permission',{method:'POST', json:permission})); }
export async function deletePermission(id:string): Promise<void> { await http(`/api/permission/${id}`, { method:'DELETE' }); }
